/**
 * Browser storage for per-browser conveniences only (theme, language, sidebar, last project):
 * never tokens or content. Storage may be unavailable (private mode, policy): reads fall back
 * to null and writes are dropped, so the choice lasts for this page only.
 */
export const local = {
  get(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set(key: string, value: string | null): void {
    try {
      if (value === null) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, value);
      }
    } catch {
      // Storage unavailable: nothing to keep.
    }
  },
};
